import normalizeUrl from 'normalize-url';
import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { Outlet, useLocation } from 'react-router-dom';

import useNavCurrentUser from '../../hooks/useNavCurrentUser';
import Nav from '../Nav';

const setUrl = (url) => {
  return normalizeUrl(url, { stripWWW: false });
};

// MetaTagLayout is a Route component that sets common meta tags for a client
// side application. It is only concerned with dynamic tags that are page
// independent. Static tags that are common across the app are served up on the
// initial page load. Tags that are specific to a page are managed by the
// componenet the page route mounts.
//
// TODO: Should the base tag be set here? It is currently set to the
//       rel_canonical value which may actually be incorrect. This could be
//       statically set at the base layout erb file.
const MetaTagLayout = () => {
  const location = useLocation();
  const [canonicalUrl, setCanonicalUrl] = useState(normalizeUrl(window.location.href));
  const [baseUrl, setBaseUrl] = useState(normalizeUrl(window.location.href));
  const { navProps, isNavCurrentUserLoading } = useNavCurrentUser();

  useEffect(() => {
    setCanonicalUrl(setUrl(window.location.href));
    setBaseUrl(setUrl(window.location.href));
  }, [location]);

  if (isNavCurrentUserLoading) {
    return null;
  }

  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:url" content={canonicalUrl} />
        <base href={baseUrl} />
      </Helmet>

      {/* TODO: Need to resolve differences between User and NavCurrentUser to insert sitewide Nav here */}
      {navProps.isFullNav && (
        <Nav
          colorScheme={navProps.colorScheme}
          currentUser={navProps.currentUser}
          isFullNav={navProps.isFullNav}
          isWebview={navProps.isWebview}
          shouldOpenReferralModal={navProps.shouldOpenReferralModal}
          newForumPostsCount={navProps.newForumPostsCount}
        />
      )}
      <Outlet />
    </>
  );
};

export default MetaTagLayout;
